import { render, staticRenderFns } from "./BlocksLibrary.vue?vue&type=template&id=5e2d3a9a&scoped=true&"
import script from "./BlocksLibrary.vue?vue&type=script&lang=js&"
export * from "./BlocksLibrary.vue?vue&type=script&lang=js&"
import style0 from "./BlocksLibrary.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BlocksLibrary.vue?vue&type=style&index=1&id=5e2d3a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d3a9a",
  null
  
)

export default component.exports